/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

const invokeClick = (elem) => {
  // Create our event (with options)
  var evt = new MouseEvent("click", {
    bubbles: true,
    cancelable: true,
    view: window,
  })
  // If cancelled, don't dispatch our event
  // eslint-disable-next-line
  var canceled = !elem.dispatchEvent(evt)
}

const autoInvokeItem = (element, delay = 300) => {
  if (element.classList.contains("c-Accordion-item")) {
    window.setTimeout(function () {
      invokeClick(element.children[0])
    }, delay)
  }
}

const invokePersonalistationJs = (delay = 500) => {
  window.setTimeout(function () {
    if (window.onload) {
      window.onload()
    }
  }, delay)
}

const scrollToCoord = (top) => {
  if (window.ieVersion() === 0) {
    window.scroll({ behavior: "smooth" }, top)
  } else {
    window.scroll(0, top)
  }
}

const scrollToHref = (href) => {
  // destination element to scroll to
  const destinationElement = document.querySelector(href)
  if (destinationElement) {
    window.setTimeout(function () {
      const topCoord =
        destinationElement.getBoundingClientRect().top + window.scrollY - 80
      scrollToCoord(topCoord)
    }, 300)
  }
}

const scroll = {
  toCoord: scrollToCoord,
  toHref: scrollToHref,
}

const saveUsersScrollPosition = () => {
  if (window.sessionStorage && window.sessionStorage.setItem) {
    window.sessionStorage.setItem(
      `@@users-scroll|${document.location.pathname}|initial`,
      window.scrollY
    )
    // console.log(
    //   "DEBUG: saved userscroll ",
    //   window.scrollY,
    //   " for path ",
    //   document.location.pathname
    // )
    return true
  }
  return false
}

const restoreUsersScrollPosition = (path) => {
  if (window.sessionStorage && window.sessionStorage.getItem) {
    window.clearTimeout(window.scrollFixTimeout)
    let lastSavedScroll = window.sessionStorage.getItem(
      `@@users-scroll|${path}|initial`
    )
    window.scrollFixTimeout = window.setTimeout(function () {
      // console.log(
      //   "DEBUG: restoreUsersScrollPosition window.scrollTo ",
      //   lastSavedScroll
      // )
      window.scrollTo(0, lastSavedScroll)
    }, 1000)
    return true
  }
  return false
}

exports.onInitialClientRender = () => {
  // inject Scripts only when not in previewMode
  if (document.location.search.indexOf("previewMode=true") === -1) {
    if (process.env.NODE_ENV === "development") {
      invokePersonalistationJs()
      // var persScript = document.createElement("script")
      // persScript.setAttribute("id", "personalisation")
      // persScript.setAttribute("type", "text/javascript")
      // persScript.onload = function() {
      //   window.onload()
      // }
      // persScript.setAttribute(
      //   "src",
      //   `${process.env.PERSONALISATION_HOST}${
      //     process.env.PERSONALISATION_JS_PATH
      //   }`
      // )

      // var persCss = document.createElement("link")
      // persCss.setAttribute("id", "personalisation-css")
      // persCss.setAttribute("type", "text/css")
      // persCss.setAttribute("rel", "stylesheet")
      // persCss.setAttribute(
      //   "href",
      //   `${process.env.PERSONALISATION_HOST}${
      //     process.env.PERSONALISATION_CSS_PATH
      //   }`
      // )
      // document.body.appendChild(persScript)
      // document.body.appendChild(persCss)
    } else {
      // if (window.upgradeAllBehaviours) {
      //   window.upgradeAllBehaviours()
      // } else {
      //   window.upgradeAllBehavioursMissing = true
      // }
    }

    // if (window.upgradeAllBehavioursMissing === true) {
    //   window.setTimeout(function() {
    //     if (window.upgradeAllBehaviours) {
    //       window.upgradeAllBehaviours()
    //     }
    //   }, 1000)
    // }
  }

  window.ieVersion = function () {
    var ua = window.navigator.userAgent
    if (ua.indexOf("Trident/7.0") > -1) {
      return 11
    } else if (ua.indexOf("Trident/6.0") > -1) {
      return 10
    } else if (ua.indexOf("Trident/5.0") > -1) {
      return 9
    } else {
      return 0 // not IE9, 10 or 11
    }
  }

  if (window.location.hash) {
    // introduce scroll offset since sticky header might cover the element
    window.setTimeout(function () {
      scroll.toHref(window.location.hash)
      //auto invoke element
      const destinationElement = document.querySelector(window.location.hash)
      if (destinationElement) {
        autoInvokeItem(destinationElement)
      }
      invokePersonalistationJs()
    }, 300)
  }

  window.addEventListener("hashchange", function (evt) {
    if (window.location.hash) {
      invokePersonalistationJs()

      window.setTimeout(function () {
        scroll.toHref(window.location.hash)
      }, 50)
    } else {
      // no hash, meaning window has moved from path#hash to path, scroll to the very top
      scroll.toCoord(0)
    }
    evt.preventDefault()
  })

  // custom handler to save last pages last scroll position when navigating without gatsby-links (unload-Event)
  window.addEventListener("unload", function () {
    saveUsersScrollPosition()
  })

  window.addEventListener("load", function () {
    if (window.location.hash === "") {
      // console.log("DEBUG: invoke restoreUsersScrollPosition from onLoad")
      restoreUsersScrollPosition(document.location.pathname)
    }
  })
}

exports.shouldUpdateScroll = ({ routerProps: { location } }) => {
  if (window.upgradeAllBehaviours) {
    window.upgradeAllBehaviours()
    if (window.location.hash) {
      // console.error(window.location.hash)
      const destinationElement = document.querySelector(window.location.hash)
      if (destinationElement) {
        autoInvokeItem(destinationElement)
      }
    }
  }

  if (window.location.hash === "") {
    // console.log(
    //   "DEBUG: invoke restoreUsersScrollPosition from shouldUpdateScroll"
    // )
    restoreUsersScrollPosition(location.pathname)
  }

  invokePersonalistationJs()

  // dont use gatsby's own scroll handler since its use of onscroll handler is
  // - inefficient ...
  // - fails for async content - retriggers onscroll not invoked by the user and so saves crappy scroll positions
  return false
}
